import { styled } from '@mui/material/styles';
import { COLORS } from '../../../theme/color';

export const NavCon = styled('div')`
  width: 100%;
  position: sticky;
  top: 0.5rem;
  z-index: 10;
  background: ${COLORS.White};
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  .nav-container {
    padding: 0;
  }

  /* Header Styles */
  .nav-header {
    padding: 1.5rem 1.5rem 1rem 1.5rem;
    background: linear-gradient(135deg, ${COLORS.MainBlue} 0%, ${COLORS.SecondaryBlue} 100%);
    color: ${COLORS.White};

    .nav-title {
      font-weight: 700;
      font-size: 1.25rem;
      margin: 0;
      letter-spacing: -0.025em;
    }

    .nav-divider {
      height: 2px;
      background: rgba(255, 255, 255, 0.2);
      margin-top: 0.75rem;
      border-radius: 1px;
    }
  }

  /* Mobile Navigation Styles */
  .mobile-nav-container {
    padding: 10px 0;

    .mobile-nav-scroll {
      display: flex;
      gap: 0.75rem;

      overflow-x: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .mobile-nav-item {
      flex-shrink: 0;
      min-width: 70px;

      padding: 0.75rem;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border: 2px solid transparent;

      &--active {
        background: linear-gradient(135deg, ${COLORS.MainBlue} 0%, ${COLORS.SecondaryBlue} 100%);
        color: ${COLORS.White};
        box-shadow: 0 4px 12px rgba(47, 77, 196, 0.3);
        transform: translateY(-2px);

        .category-filter-link {
          color: ${COLORS.White} !important;
        }

        .category-image-container {
          background: rgba(255, 255, 255, 0.2);
        }
      }

      &--inactive {
        background: ${COLORS.White};
        color: ${COLORS.MainBlack};
        border-color: ${COLORS.MainGray};

        &:hover {
          border-color: ${COLORS.MainBlue};
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(47, 77, 196, 0.15);
        }
      }
    }
  }

  /* Category Filter Styles */
  .category-filter-link {
    text-decoration: none;
    color: inherit;
    display: block;
    width: 100%;

    &:hover {
      text-decoration: none;
    }
  }

  .category-filter-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .category-image-container {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    overflow: hidden;
    background: ${COLORS.MildGray};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .category-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .category-name {
    font-size: 0.75rem;
    font-weight: 500;
    margin: 0;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
  }

  /* Desktop Navigation Styles */
  .desktop-nav-container {
    padding: 0.5rem 0;

    .desktop-nav-item {
      margin: 0.25rem 0;
    }
  }

  /* Loading Styles */
  .loading-container {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    .loading-item {
      padding: 0;
    }
  }

  /* Logout Section Styles */
  .logout-section {
    margin-top: 1rem;

    .logout-divider {
      height: 1px;
      background: ${COLORS.MainGray};
      margin: 0 1rem 1rem 1rem;
    }

    .logout-item {
      padding: 0;
    }

    .logout-button {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.875rem 1.5rem;
      background: none;
      border: none;
      color: ${COLORS.MainRed};
      font-weight: 500;
      font-size: 0.875rem;
      cursor: pointer;
      transition: all 0.2s ease;
      border-radius: 0;

      &:hover {
        background: ${COLORS.MildestGray};
        color: ${COLORS.DarkRed};
      }

      &:active {
        transform: scale(0.98);
      }

      .logout-icon {
        flex-shrink: 0;
      }

      span {
        text-transform: capitalize;
      }
    }
  }

  /* Responsive adjustments */
  @media (max-width: 900px) {
    border-radius: 0;
    box-shadow: none;
    background: transparent;

    .mobile-nav-container {
      padding: 0.5rem 0;
    }
  }
`;

export const SkeletonCon = styled('div')`
  padding: 0;
`;
